import type { IconNames } from '@repo/foundations';

export const ACTIVITY_TYPE_TO_ICON: Record<string, IconNames> = {
	DELETE_ENTITY: 'trash',
	CREATE_ENTITY: 'fileAnalytics',
	PROPAGATE_ENTITY: 'arrowsSplit',
	UPDATE_ENTITY_DESCRIPTION: 'pencil',
	ADD_ENTITY_OWNER: 'user',
	REMOVE_ENTITY_OWNER: 'user',
	ADD_ENTITY_COLLECTION: 'folders',
	REMOVE_ENTITY_COLLECTION: 'folders',
	SET_ENTITY_AS_PUBLISHED: 'pencil',
	SET_ENTITY_AS_UNPUBLISHED: 'pencil',
	SET_ENTITY_AS_PII: 'shieldCheckFilled',
	SET_ENTITY_AS_NOT_PII: 'shield',
	SET_ENTITY_AS_VERIFIED: 'discountCheckFilled',
	SET_ENTITY_AS_UNVERIFIED: 'rosette',
	UPDATE_ENTITY_DEFINITION: 'pencil',
	ADD_ENTITY_TAG: 'tag',
	REMOVE_ENTITY_TAG: 'tag',
	ARCHIVE_ENTITY: 'trash',
	RESTORE_ARCHIVED_ENTITY: 'restore',
	ADD_ENTITY_SUBSCRIBER: 'user',
	REMOVE_ENTITY_SUBSCRIBER: 'user',
	ADD_ENTITY_TEAM: 'usersGroup',
	REMOVE_ENTITY_TEAM: 'usersGroup',
	UPDATE_ENTITY_TITLE: 'pencil',
	CREATE_AUTOMATION: 'bolt',
	CREATE_MONITOR: 'activity',
	CREATE_DATA_ACCESS_REQUEST: 'squareRoundedCheck',
	CREATE_INTEGRATION: 'plugConnected',

	// Policy Icons
	CREATE_POLICY: 'fileCheck',
	DELETE_POLICY: 'trash',
	ENABLE_POLICY: 'toggleRight',
	DISABLE_POLICY: 'toggleLeft',
	UPDATE_POLICY_SEVERITY: 'priorityMedium',
};

export const getEntityIconByType = (type: string): IconNames => {
	switch (type) {
		case 'table':
			return 'table';
		case 'column':
			return 'columns';
		case 'dashboard':
			return 'presentationAnalytics';
		case 'chart':
			return 'chartBar';
		case 'job':
			return 'cylinder';
		case 'collection':
			return 'folder';
		case 'dictionary_term':
			return 'book';
		case 'metric':
			return 'chartHistogram';
		case 'document':
			return 'file';
		case 'event':
			return 'click';
		case 'question':
			return 'messageCircleQuestion';
		case 'schema':
			return 'schema';
		case 'database':
			return 'database';
		case 'glossary':
			return 'book';
		default:
			return 'folder';
	}
};

export const PENDING_VERSION_HISTORY = 'PENDING_VERSION_HISTORY';
